import { render } from "./YearKpi.vue?vue&type=template&id=5da3cbf8&scoped=true"
import script from "./YearKpi.vue?vue&type=script&lang=js"
export * from "./YearKpi.vue?vue&type=script&lang=js"

import "./YearKpi.vue?vue&type=style&index=0&id=5da3cbf8&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da3cbf8"]])

export default __exports__